import React from "react";

const AboutUs = () => {
  return (
    <div>
      {/* Responsive Banner Image with Overlay */}
      <div className="position-relative">
        <img
          src="https://www.sunstar.com/media_18e9dcd7276d4163ffe2096dc5533439f1879f828.jpeg?width=750&format=jpeg&optimize=medium"
          alt="Laboratory Banner"
          className="img-fluid w-100"
          style={{ maxHeight: "350px", objectFit: "cover" }}
        />
        <div
          className="position-absolute top-50 start-50 translate-middle text-white text-center"
          style={{ textShadow: "2px 2px 8px rgba(0,0,0,0.7)" }}
        >
        </div>
      </div>

      {/* Content Section */}
      <div className="container my-5">
        <h2 className="mb-4 fw-semibold text-primary">About Our Laboratory</h2>
        <p style={{ fontSize: "1.1rem", color: "#555" }}>
          <strong>Advanced Research Labs</strong> has been at the forefront of scientific innovation since 2005. Equipped
          with cutting-edge technology and staffed by highly skilled professionals, our laboratory provides precise and
          reliable testing services across various scientific fields.
        </p>
        <p style={{ fontSize: "1.1rem", color: "#555" }}>
          We take pride in our commitment to quality and accuracy, serving researchers, healthcare providers, and industries
          with timely results and exceptional customer support. Our rigorous quality assurance processes ensure compliance
          with international standards and best practices.
        </p>
        <p style={{ fontSize: "1.1rem", color: "#555" }}>
          Continuous improvement and adaptation to emerging scientific trends drive us forward, enabling Advanced Research
          Labs to maintain its reputation as a trusted partner in research and development. We are passionate about
          contributing to scientific progress and improving lives through innovation.
        </p>
        <p style={{ fontSize: "1.1rem", color: "#555" }}>
          Our laboratory specializes in environmental testing, molecular biology, clinical diagnostics, and chemical analysis.
          We collaborate closely with universities, healthcare institutions, and industries to support their research and
          product development needs.
        </p>
        <p style={{ fontSize: "1.1rem", color: "#555" }}>
          Equipped with state-of-the-art instrumentation and certified by international quality bodies, we ensure that every
          analysis meets the highest standards of precision and reliability. Our team continually trains and upgrades its
          skills to stay ahead in this fast-evolving scientific landscape.
        </p>
        <p style={{ fontSize: "1.1rem", color: "#555" }}>
          At Advanced Research Labs, we believe that science is a collaborative journey. We invite our clients and partners
          to engage with us in creating solutions that drive innovation and contribute to a healthier, safer world.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
